//  * @package         src/components/Dashboard
//  * @author          Riddhi D Parekh
//  * @date            22nd October 2018
//  * @type            Main parent Component File
//  * @description -   This file renders the html and functionality that renders and manages all child components in the app.
<template>
  <div class="content_bg build_page" :class="{ 'published-survey': all.in_status == constantCommonConfig.SURVEY_PUBLISHED }">
    <div class="row m-0">
      <!-- <h1>{{ surveyData }}</h1> -->
      <!-- <button type="button" @click="logout">log out</button> -->
      <topbar-dashboard v-if="!isFullScreen"></topbar-dashboard>

      <component :key="skipLogicKey" v-if="isSkipLogic === true" v-bind:is="skiplogicComponent"></component>
      <left-dashboard v-else></left-dashboard>

      <!-- <center-dashboard></center-dashboard>
      <right-dashboard></right-dashboard>-->
      <!-- <centerright v-if="isSkipLogic === true"></centerright> -->
      <component v-if="isSkipLogic === false" v-bind:is="centerComponent"></component>
      <component v-if="isSkipLogic === false" v-bind:is="rightComponent"></component>
    </div>

    <button
      v-if="isAiFormAllowed && !isFullScreen && !isSkipLogic && !alexOpen"
      type="button"
      class="alex-launcher"
      @click="toggleAlexPanel"
      aria-label="Open Tracey AI assistant"
    >
      <img
        class="alex-launcher__avatar"
        :src="traceyLauncherImg"
        alt="Tracey"
        width="64"
        height="64"
      />
    </button>

    <!-- Keep ChatPanel mounted after first open (v-show) so close/reopen preserves session and messages without a full page reload. -->
    <div
      v-if="isAiFormAllowed && alexChatMounted"
      v-show="alexOpen"
      class="alex-shell"
      role="presentation"
      :aria-hidden="alexOpen ? 'false' : 'true'"
    >
      <div class="alex-shell__backdrop" @click="closeAlex"></div>
      <aside
        class="alex-shell__drawer"
        role="dialog"
        aria-modal="true"
        aria-labelledby="tracey-drawer-title"
        @click.stop
      >
        <header class="alex-shell__header">
          <h2 id="tracey-drawer-title" class="alex-shell__title">Tracey</h2>
          <button type="button" class="alex-shell__close" @click="closeAlex" aria-label="Close Tracey assistant">
            ×
          </button>
        </header>
        <div class="alex-shell__body">
          <ai-form-builder-chat-panel
            :key="traceyChatPanelKey"
            :survey-id="$route.params.id"
            embedded
            @applied="onAlexFormApplied"
          />
        </div>
      </aside>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import { EventBus } from "../../main";
import topbarDashboard from "./topbar";
import leftDashboard from "./left";
import centerDesign from "./centerdesign";
import rightDesign from "./rightdesign";
import centerSetting from "./centersetting";
import rightSetting from "./rightsetting";
import centerQuestions from "./centerquestions";
import rightQuestions from "./rightquestions";
import skipLogic from "./skipLogic";
var { redirectUrl, constantCommonConfig } = require("../../../config/config.js");

export default {
  name: "App",
  // props: ['surveyData'],
  metaInfo() {
    return {
      title: this.siteTitle
    };
  },
  components: {
    topbarDashboard,
    leftDashboard,
    centerDesign,
    rightDesign,
    centerSetting,
    rightSetting,
    centerQuestions,
    rightQuestions,
    skipLogic

    // surveyMobileSettings,
    // surveyOnlineSettings
  },
  data() {
    return {
      centerComponent: "centerQuestions",
      rightComponent: "rightQuestions",
      skiplogicComponent: "skipLogic",
      tab: null,
      data: [],
      constantCommonConfig: constantCommonConfig,
      siteTitle: '',
      alexOpen: false,
      /** Once true, Tracey shell stays in DOM (hidden with v-show) so chat state survives drawer close. */
      alexChatMounted: false,
      isAiFormAllowed: false,
      traceyLauncherImg: require("../../assets/images/tracey.png")
    };
  },
  computed: {
    ...mapGetters("LeftSidebarCreate", ["isError", "all", "loading"]),
    ...mapGetters("editquestionEdit", [
      "isSkipLogic",
      "skipLogicKey",
      "isFullScreen"
    ]),
    /**
     * New value on each full browser load (reload / open tab) so Tracey remounts
     * and starts a new chat session. Same document + same survey => same key, so
     * closing/reopening the drawer keeps one session without a page reload.
     */
    traceyChatPanelKey() {
      const surveyId = this.$route.params.id || "survey";
      const origin =
        typeof performance !== "undefined" &&
        performance.timeOrigin != null &&
        !Number.isNaN(performance.timeOrigin)
          ? String(Math.floor(performance.timeOrigin))
          : "0";
      return "tracey-chat-" + surveyId + "-" + origin;
    }
  },
  watch: {
    // As always only questions are to be displayed
    // tab: function(val) {
    //   if (val == "designleft") {
    //     this.centerComponent = "centerDesign";
    //     this.rightComponent = "rightDesign";
    //   } else if (val == "settingleft") {
    //     this.centerComponent = "centerSetting";
    //     this.rightComponent = "rightSetting";
    //   }
    // For rendering drag components pass component value in $emit tab value and set that variable directly for rendering.......
    // else {
    //   this.centerComponent = "centerQuestions";
    //   this.rightComponent = "rightQuestions";
    // }
    // },
    // Show progress bar bases on loading watcher
    loading: function(val) {
      if(val)
        this.$Progress.start();
      else
        this.$Progress.finish();
    },
    isError: function(val) {
      if (val) {
        window.location.href =
          redirectUrl + process.env.CAKE_BASE_PATH + "error";
        // this.$router.push({ name: "ErrorPage" });
      }
    }
  },
  async created() {
    // Using the service bus
    EventBus.$on("LeftTabSelected", tab => {
      this.tab = tab;
    });
  },
  beforeMount: async function() {
    this.data = this.$session.getAll();
    this.isAiFormAllowed = Number(this.$session.get("in_is_allow_ai_form") || 0) === 1;
    this.data["in_survey_Id"] = this.$route.params.id;
    if (this.$route.path.includes("createform") || !this.all.flag)
      await this.getSurveyById(this.data);
    this.siteTitle = (this.$route.path.includes("createform")) ? 'Create Form' : (this.all.in_status == 1 ? 'Form' : 'Draft Form');
    await this.fetchAllSurveyTypes(this.data);
  },
  mounted: async function() {
    if (typeof window !== "undefined") {
      window.addEventListener("pageshow", this.onTraceyPageShow);
    }
    await this.getWhiteLabelDetails();
    await this.fetchAiFormBuilderAccess();
  },
  beforeDestroy() {
    if (typeof window !== "undefined") {
      window.removeEventListener("pageshow", this.onTraceyPageShow);
    }
  },
  methods: {
    ...mapActions("LeftSidebarCreate", ["getSurveyById", "fetchAllSurveyTypes"]),
    toggleAlexPanel() {
      if (!this.alexOpen) {
        this.alexChatMounted = true;
      }
      this.alexOpen = !this.alexOpen;
    },
    closeAlex() {
      this.alexOpen = false;
    },
    /** BFCache restore: tear down Tracey so next open remounts and creates a new session. */
    onTraceyPageShow(ev) {
      if (ev && ev.persisted) {
        this.alexOpen = false;
        this.alexChatMounted = false;
      }
    },
    async onAlexFormApplied() {
      const data = this.$session.getAll();
      data["in_survey_Id"] = this.$route.params.id;
      await this.getSurveyById(data);
      EventBus.$emit("aiFormAppliedRefresh");
    },
    async getWhiteLabelDetails() {
      var parts = window.location.href.split('.')
      // parts[0] = 'http://hispec';
      // parts[1] = 'hispecservices';
      // parts[2] = 'com/doyenhub';
      if (parts[0].includes('//')) parts[0] = parts[0].split('//')[1]
      let domain = parts[0]
      let whitelabel = this.$route.params.whitelabel
      let url = process.env.API_PATH + "/getDomainDetails";
      await axios
        .post(
          url,
          {
            st_subdomain: domain,
            st_whitelabel: whitelabel
          },
          {
            headers: { "Content-Type": "application/json" }
          }
        )
        .then(response => {
          if (response.data.flag === 1) {
            var designdata = response.data.data;
            // Updating favicon according to whitelabel details
            if (designdata.favicon_image_url && designdata.favicon_image_url.length > 0) {
              const favicon = document.getElementById("favicon");
              favicon.href = designdata.favicon_image_url;
            }
          } else if (response.data.flag === 4) {
            console.log("invalid account name");
            this.$awn.alert("The page you requested does not exists.");
            var loc = location.host;
            var locArr = loc.split(".");
            loc = location.protocol + "//" + locArr[1] + "." + locArr[2];
            window.location.href = loc;
          } else {
            console.log("invalid url");
            this.$awn.alert("The page you requested does not exists.");
            window.location.href = redirectUrl;
          }
        })
        .catch();
    },
    async fetchAiFormBuilderAccess() {
      try {
        const res = await axios.post(
          process.env.API_PATH + "/chatbot/feature/access",
          {
            lang: this.$session.get("lang"),
            request_id: this.$session.get("requestId")
          },
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: this.$session.get("jwt_token")
            }
          }
        );
        const allowed =
          res &&
          res.data &&
          res.data.flag === 1 &&
          Number(
            res.data.data && res.data.data.in_is_allow_ai_form != null
              ? res.data.data.in_is_allow_ai_form
              : 0
          ) === 1;
        this.isAiFormAllowed = allowed;
        if (!allowed) {
          this.alexOpen = false;
          this.alexChatMounted = false;
        }
      } catch (e) {
        this.isAiFormAllowed = Number(this.$session.get("in_is_allow_ai_form") || 0) === 1;
      }
    }
  }
};
</script>

<style scoped>
.build_page {
  position: relative;
}
.alex-launcher {
  position: fixed;
  z-index: 1040;
  right: 24px;
  bottom: 24px;
  border: none;
  padding: 0;
  background: transparent;
  cursor: pointer;
}
.alex-launcher:focus {
  outline: 2px solid rgba(74, 144, 217, 0.6);
  outline-offset: 3px;
}
.alex-launcher__avatar {
  display: block;
  width: 130px;
  height: 130px;
  border-radius: 10%;
  object-fit: cover;
 
}
.alex-launcher:hover .alex-launcher__avatar {
  transform: scale(1.05);
}

.alex-shell {
  position: fixed;
  inset: 0;
  z-index: 1050;
  pointer-events: none;
}

.alex-shell__backdrop {
  position: absolute;
  inset: 0;
  background: rgba(15, 23, 42, 0.38);
  pointer-events: auto;
  animation: alex-bd-in 0.2s ease both;
}

@keyframes alex-bd-in {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.alex-shell__drawer {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  width: min(432px, 100vw);
  max-width: 100vw;
  display: flex;
  flex-direction: column;
  background: #fff;
  box-shadow: -8px 0 32px rgba(0, 0, 0, 0.12);
  pointer-events: auto;
  animation: alex-dr-in 0.24s cubic-bezier(0.4, 0, 0.2, 1) both;
}

@keyframes alex-dr-in {
  from {
    transform: translateX(100%);
  }
  to {
    transform: translateX(0);
  }
}

.alex-shell__header {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 14px;
  border-bottom: 1px solid #e2e8f0;
  background: #fff;
}

.alex-shell__title {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: #1e293b;
}

.alex-shell__close {
  border: none;
  background: transparent;
  font-size: 28px;
  line-height: 1;
  color: #64748b;
  cursor: pointer;
  padding: 0 4px;
  border-radius: 4px;
}

.alex-shell__close:hover {
  color: #0f172a;
  background: #f1f5f9;
}

.alex-shell__body {
  flex: 1;
  min-height: 0;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}
</style>
<!-- <style lang="scss">
@import '../../assets/scss/style'
</style> -->



// WEBPACK FOOTER //
// src/components/Dashboard/Main.vue